<template>
  <div class="relative min-h-screen">
    <div class="flex justify-center" v-if="isLoading">
      <bar-loader class="my-8" color="#4db1fa" :width="320" />
    </div>

    <div class="flex flex-col items-center pt-8 pb-48 px-8" v-else>
      <section class="bg-white legacy-html" v-html="aboutLegacy"></section>

      <video
        class="mt-8 max-w-lg h-auto"
        src="/videos/about.mp4"
        controls
        autoplay
        muted
      ></video>
    </div>

    <base-footer class="absolute bottom-0" />
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      isLoading: true,
      aboutLegacy: "",
    };
  },
  async created() {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL}/settings/about`
      );
      this.aboutLegacy = data;
    } catch (e) {
      // Ignore
    } finally {
      this.isLoading = false;
    }
  },
};
</script>
